import React from 'react';

/**
 * SEO Component (React 19 Native)
 * 
 * This component uses React 19's native support for metadata hoisting.
 * Simply rendering <title>, <meta>, and <link> tags inside any component
 * now automatically moves them to the <head> of the document.
 */
const SEO = ({ title, description, keywords, image, url, noIndex }) => {
    const siteName = "NSO India";
    
    // Formatting logic to ensure titles are clean (no hyphens, proper capitalization)
    const formatTitle = (text) => {
        if (!text || typeof text !== 'string') return '';
        // Special case for FAQ, About Us, etc.
        if (text.toUpperCase() === 'FAQ') return 'FAQ';
        const clean = text.replace(/-us$/i, ' Us');
        return clean.split('-').map(word => {
            if (word.toUpperCase() === 'FAQ') return 'FAQ';
            return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
        }).join(' ');
    };

    const cleanTitle = formatTitle(title);
    const displayTitle = cleanTitle ? (cleanTitle.includes(siteName) ? cleanTitle : `${cleanTitle} | ${siteName}`) : `NSO India | Premium E-commerce Destination`;

    // THE DEFINITIVE FIX: Directly tell the browser to update the tab title
    React.useEffect(() => {
        if (typeof document !== 'undefined') {
            document.title = displayTitle;
        }
    }, [displayTitle]);

    const defaultDescription = "NSO India is your premium digital marketplace for high-quality optical eyewear and the latest smartphones. Shop now for the best deals!";
    const metaDescription = description || defaultDescription;
    const metaKeywords = keywords || "NSO India, NSO, nso-india.com, e-commerce, shopping, smartphones, mobile phones, optical, eyewear, sunglasses";
    const siteUrl = "https://www.nso-india.com/";
    const logoUrl = "https://www.nso-india.com/logo.png";

    return (
        <React.Fragment>
            {/* Native tags for search engines */}
            <title>{displayTitle}</title>
            <meta name="description" content={metaDescription} />
            <meta name="keywords" content={metaKeywords} />
            
            {/* Control indexing */}
            {noIndex && <meta name="robots" content="noindex, follow" />}

            {/* Open Graph / Facebook */}
            <meta property="og:type" content="website" />
            <meta property="og:url" content={url || siteUrl} />
            <meta property="og:title" content={displayTitle} />
            <meta property="og:description" content={metaDescription} />
            <meta property="og:image" content={image || logoUrl} />
            <meta property="og:site_name" content={siteName} />

            {/* Twitter */}
            <meta property="twitter:card" content="summary_large_image" />
            <meta property="twitter:url" content={url || siteUrl} />
            <meta property="twitter:title" content={displayTitle} />
            <meta property="twitter:description" content={metaDescription} />
            <meta property="twitter:image" content={image || logoUrl} />

            {/* Canonical Tag */}
            <link rel="canonical" href={url || siteUrl} />
        </React.Fragment>
    );
};

export default SEO;
